import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { error } from 'protractor';

@Injectable({
  providedIn: 'root'
})
export class ErrorsService {

  constructor(
    public router: Router,
  ) {}


  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       ERRORES desde el servidor       /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  requestError(err){
    switch (err.status) {
      case 401: //Autenticación: servidor no recive el token / token expirado
        Swal.fire({
                  allowOutsideClick: false,
                  html: `
                    <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood_bad</i> <br><br>
                    <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: auto; align-items: center; text-align: center; color: #171994;">Favor reingresar</h1>
                    <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;"></p><br>`,
                  showConfirmButton: false,
                  timer: 3000
                });
        setTimeout(() => this.router.navigate(['login']), 2000); // setTimeout(() => ; this._usuarioService.logout(), 2000);
        break;
      case 403: // Servicio sin permiso
        Swal.fire({
                  allowOutsideClick: false,
                  html: `
                    <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood_bad</i> <br><br>
                    <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: auto; align-items: center; text-align: center; color: #171994;">Acceso no autorizado</h1>
                    <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;"></p><br>`,
                  showConfirmButton: false,
                  timer: 3000
                });
        // throw (err.error.msg);
        break;
      case 405: // Solicitudes no permitidas
         Swal.fire({
                  allowOutsideClick: false,
                  html: `
                    <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood_bad</i> <br><br>
                    <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: auto; align-items: center; text-align: center; color: #171994;">Error</h1>
                    <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;"></p><br>`,
                  showConfirmButton: false,
                  timer: 3000
                });
        break;

      case 500: // Error entre servidor - BD, problemas de query, etc.
      
         Swal.fire({
                  allowOutsideClick: false,
                  html: `
                    <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood_bad</i> <br><br>
                    <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: auto; align-items: center; text-align: center; color: #171994;">Error servidor</h1>
                    <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;"></p><br>`,
                  showConfirmButton: false,
                  timer: 3000
                });
        break;
      
      case 0:
       
         Swal.fire({
                  allowOutsideClick: false,
                  html: `
                    <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood_bad</i> <br><br>
                    <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: auto; align-items: center; text-align: center; color: #171994;">Error de conexión</h1>
                    <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;"></p><br>`,
                  showConfirmButton: false,
                  timer: 3000
                });
        setTimeout(() => window.location.reload(), 10*1000);
        break;

      default:
        Swal.fire({
                  allowOutsideClick: false,
                  html: `
                    <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood_bad</i> <br><br>
                    <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: auto; align-items: center; text-align: center; color: #171994;">Error en el servicio</h1><br>
                    <h1 style="font-family: Mulish; font-style: normal; font-weight: 600;font-size: 28px; line-height: auto; align-items: center; text-align: center; color: #171994;">Favor de actualizar el sitio</h1>
                    <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;"></p><br>`,
                  showConfirmButton: false,
                  timer: 3000
                });
        break;
    }
  }




}
